import { Box, Divider, makeStyles } from '@dxb-web-ui-framework/design-system';
import React, { VFC } from 'react';
import { useTranslation } from 'react-i18next';
import { AccountExtraitTransaction } from '../../../domain/Transaction/entities/AccountExtraitTransaction';
import { Mandate } from '../../../../../authorizations/src/domain/Authorization/entities';
import { MatchButtons } from '../../../../../content-composer/src/components/Generic/MatchButtons';

export interface TransactionDetailsContentProps {
  transaction: AccountExtraitTransaction | Mandate;
  isStandalonePage: boolean;
  isLoading: boolean;
  onToggleDrawer?: (transactionId: any) => void;
  lastAuthorizer?: boolean;
  actionCallback?: (event: any, name: string, transactionNo: string, isActionFromDetailsDrawer: boolean) => void;
}

const useStyles = makeStyles(theme => ({
  authorizationButtonsMobile: {
    background: theme.palette.common.white,
    width: '100%',
    position: 'sticky',
    bottom: 0,
  },
}));

const TransactionDetailsAuthorizationButtons: VFC<TransactionDetailsContentProps> = ({
  transaction,
  isStandalonePage,
  onToggleDrawer,
  isLoading,
  lastAuthorizer,
  actionCallback,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Box className={isStandalonePage ? classes.authorizationButtonsMobile : ''}>
        {isStandalonePage && <Divider />}
        <Box
          p={isStandalonePage ? 2 : 0}
          mt={isStandalonePage ? 0 : 8}
          display={'flex'}
          alignItems={'flex-end'}
          justifyContent={isStandalonePage ? 'space-evenly' : 'flex-end'}>
          {!isStandalonePage && (
            <MatchButtons
              isFullWidth
              leftBtnFullWidth
              leftBtnTitle={t('accountsDetailsPage.TransactionDetailsAuthorizationButtons.Reject')}
              onClickLeftBtn={e => {
                if (actionCallback) {
                  actionCallback(e, 'reject', transaction.transactionId, true);
                }
              }}
              leftBtnHasSkeleton={isLoading}
              leftBtnLabel={t('accountsDetailsPage.TransactionDetailsAuthorizationButtons.Reject')}
              rightBtnFullWidth
              rightBtnTitle={
                !lastAuthorizer
                  ? t('accountsDetailsPage.TransactionDetailsAuthorizationButtons.Approve')
                  : t('accountsDetailsPage.TransactionDetailsAuthorizationButtons.ApproveFinal')
              }
              onClickRightBtn={e => {
                if (actionCallback) {
                  actionCallback(e, 'approve', transaction.transactionId, true);
                }
              }}
              rightBtnHasSkeleton={isLoading}
              rightBtnLabel={
                !lastAuthorizer
                  ? t('accountsDetailsPage.TransactionDetailsAuthorizationButtons.Approve')
                  : t('accountsDetailsPage.TransactionDetailsAuthorizationButtons.ApproveFinal')
              }
            />
          )}
          {isStandalonePage && (
            <MatchButtons
              isFullWidth={true}
              leftBtnFullWidth={true}
              leftBtnTitle={t('accountsDetailsPage.TransactionDetailsAuthorizationButtons.Reject')}
              onClickLeftBtn={e => {
                if (actionCallback) {
                  actionCallback(e, 'reject', transaction.transactionId, true);
                }
              }}
              leftBtnHasSkeleton={isLoading}
              leftBtnLabel={t('accountsDetailsPage.TransactionDetailsAuthorizationButtons.Reject')}
              rightBtnFullWidth={true}
              rightBtnTitle={
                !lastAuthorizer
                  ? t('accountsDetailsPage.TransactionDetailsAuthorizationButtons.Approve')
                  : t('accountsDetailsPage.TransactionDetailsAuthorizationButtons.ApproveFinal')
              }
              onClickRightBtn={e => {
                if (actionCallback) {
                  actionCallback(e, 'approve', transaction.transactionId, true);
                }
              }}
              rightBtnHasSkeleton={isLoading}
              rightBtnLabel={
                !lastAuthorizer
                  ? t('accountsDetailsPage.TransactionDetailsAuthorizationButtons.Approve')
                  : t('accountsDetailsPage.TransactionDetailsAuthorizationButtons.ApproveFinal')
              }
            />
          )}
        </Box>
      </Box>
    </>
  );
};

export { TransactionDetailsAuthorizationButtons };
